import React, { useCallback, useMemo } from 'react';
import { Modal } from '@mantine/core';
import { useDownloadState } from '@shakkerai/pro-store';
import { downloadImage } from '@shakkerai/pro-utils';
import { Image, Button } from '@shakkerai/pro-components';
import logo from './watermarker.png';
import { convert2CompressedUrl } from '@shakkerai/util-image';
import { mc } from '@shakkerai/report';

/**
 * 下载确认弹窗，支持水印
 */
export const DownloadModal = () => {
  const { downloadModalVisible, imageId, imageUrl, closeDownloadModal } = useDownloadState();

  const fileName = useMemo(() => {
    const arr = imageUrl?.split('/');
    const filename = arr[arr.length - 1] ? arr[arr.length - 1].split('?')[0] : '';
    return filename;
  }, [imageUrl]);

  const download = useCallback(() => {
    downloadImage(imageUrl);
    closeDownloadModal();
    mc('tool.canvas.download', { image_id: imageId, type: 'original' });
  }, [imageUrl, imageId, closeDownloadModal]);

  // d2F0ZXJtYXJrL2xpYndhdGVybWFyay5wbmc=
  // d2F0ZXJtYXJrL3BpY3dhdGVybWFyay5wbmc=

  const downloadWithWatermark = useCallback(() => {
    const url = `${imageUrl}?x-oss-process=image/watermark,image_d2F0ZXJtYXJrL3hpbmdsaXVfd2F0ZXJtYXJrLnBuZw==,g_se,x_12,y_12&attname=${fileName}`;
    downloadImage(url);
    closeDownloadModal();
    mc('tool.canvas.download', { image_id: imageId, type: 'watermark' });
  }, [imageUrl, imageId, fileName, closeDownloadModal]);

  return (
    <Modal opened={downloadModalVisible} onClose={closeDownloadModal} title="下载图片" centered>
      <div className="flex gap-[10px]">
        <Image src={convert2CompressedUrl(imageUrl, 300)} className="w-[240px] h-[320px] rounded" />

        <div className="relative">
          <img src={logo} alt="" className="absolute right-2 bottom-2 z-[1] h-5" />
          <Image src={convert2CompressedUrl(imageUrl, 300)} className="w-[240px] h-[320px] rounded" />
        </div>
      </div>
      <div>
        <div className="flex mt-[10px] gap-[10px]">
          <Button className="w-[0] flex-[1] p-[10px]" onClick={download}>
            直接下载
          </Button>
          <Button className="w-[0] flex-[1] p-[10px]" onClick={downloadWithWatermark}>
            生成AI标识并下载
          </Button>
        </div>
      </div>
    </Modal>
  );
};
